import '../css/404.css';

export default function NotFound() {

    document.querySelector("body").setAttribute("class", "")
    return (
        <>
            <div id="notfound">
                <div className="notfound-bg">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div className="notfound">
                    <div className="notfound-404">
                        <h1>404</h1>
                    </div>
                    <h2>Página no encontrada</h2>
                    {/* <p>La página que buscas no existe</p> */}
                    {/* <a href="#">Inicio</a> */}
                </div>
            </div>
        </>
    )
}
